import { useStore } from '../store/store';
import { patchBoxContent } from './useEditorCollab';
import { flushStructureSync } from './structureSync';
import {
  flushBoxDraftPersist,
  requeueRejectedSaves,
  retryPendingSaves,
  waitForPendingSaves,
} from './persistence';

// À appeler avant de quitter un document : envoie tout de suite ce qui attend
// encore (texte en cours de frappe, brouillon débouncé, diff structurel
// débouncé) et attend la réponse du serveur. Vrai = tout est enregistré, on
// peut partir sans rien perdre.
export const flushPendingSaves = async () => {
  const { handleUnSelectBox, handleUnSelectContainer } = useStore.getState();
  // Les éditeurs (texte, titre, cellule...) écrivent leur contenu dans le
  // store quand leur box cesse d'être sélectionnée, au rendu qui suit : on
  // laisse passer ce rendu avant d'envoyer, comme saveDocument (hooks.js).
  handleUnSelectBox();
  handleUnSelectContainer();
  await new Promise((resolve) => setTimeout(resolve, 0));

  patchBoxContent.flush();
  flushBoxDraftPersist();
  flushStructureSync();

  // Ce qui attend un nouvel essai part tout de suite. Hors connexion, rien ne
  // part : waitForPendingSaves répond non tant que la file n'est pas vide.
  retryPendingSaves();
  return waitForPendingSaves();
};

// Bouton « Enregistrer » affiché après un échec : envoie tout ce qui attend,
// y compris ce que le serveur avait refusé. Vrai = tout est enregistré.
export const saveNow = () => {
  requeueRejectedSaves();
  return flushPendingSaves();
};
